import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  TextFieldProps,
} from '@mui/material';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import DatePicker from '../../../../../../../../components/DatePicker/DatePicker';
import { useRootContext } from '../../../../../../../../components/RootContainer';
import { FileExcelIcon } from '../../../../../../../../components/SvgIcons/FileExcelIcon';
import { FilePdfIcon } from '../../../../../../../../components/SvgIcons/FilePdfIcon';
import { dateApiParser } from '../../../../../../../../utils/DateHelpers';
import { outputDateValue } from '../../../../../../../../utils/InputOutputDateFormat';
import { FooterExtraButtons } from '../../../../../../components/FooterButtons';
import { ReportLabel } from '../../../../../../components/ReportLabel';
import { FlashManagerReportFormModel } from '../../models';

export const FilterForm: FC<{
  onSubmit: (data: FlashManagerReportFormModel) => void;
  onReset: () => void;
}> = ({ onSubmit, onReset }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext<FlashManagerReportFormModel>();

  const { globalSettings } = useRootContext();

  const formValues = watch();

  return (
    <Box sx={{ p: 0, height: '100%', backgroundColor: 'colors.gray.o10', overflowY: 'scroll' }}>
      <Stack direction={'column'} spacing={0} sx={{ width: '100%', height: '100%' }}>
        <ReportLabel label="Flash Manager" />
        <Stack direction={'row'} spacing={0}>
          <Stack
            direction={'column'}
            spacing={2}
            sx={{
              p: 3,
            }}
          >
            <Controller
              control={control}
              name="date"
              render={({ field }) => (
                <DatePicker
                  maxDate={dateApiParser(globalSettings?.frontend_date!)}
                  value={field.value}
                  label={'Date'}
                  onChange={(date: Date) => field.onChange(outputDateValue(date))}
                  renderInput={(params: TextFieldProps) => (
                    <TextField
                      {...params}
                      size="medium"
                      variant="standard"
                      sx={{
                        width: '100%',
                      }}
                      label="Date"
                      error={Boolean(errors?.date)}
                      helperText={errors?.date?.message}
                      onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
                      placeholder="mm/dd/yyyy"
                    />
                  )}
                />
              )}
            />

            <Controller
              control={control}
              name="show_net"
              render={({ field }) => (
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="gros"
                    name="radio-buttons-group"
                    row
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      const selectedOption = (event.target as HTMLInputElement).value;
                      field.onChange(selectedOption === 'net');
                    }}
                    value={field.value ? 'net' : 'gros'}
                  >
                    <FormControlLabel
                      sx={{ color: 'black' }}
                      value="gros"
                      control={<Radio />}
                      label="Gross Revenue"
                    />
                    <FormControlLabel
                      sx={{ color: 'black' }}
                      value="net"
                      control={<Radio />}
                      label="Net Revenue"
                    />
                    {/* <FormControlLabel sx={{ color: "black" }} value="other" control={<Radio />} label="Without VAT" /> */}
                  </RadioGroup>
                </FormControl>
              )}
            />

            <Box sx={{ height: 10 }} />
          </Stack>
        </Stack>
        {/* <FooterButtons onSubmit={handleSubmit(onSubmit)} onReset={onReset} /> */}

        <FooterExtraButtons
          onSubmit={file_type => {
            setValue('file_type', file_type);
            handleSubmit(onSubmit)();
          }}
          onReset={onReset}
          exportFileTypes={[
            {
              label: 'PDF',
              value: 'pdf',
              icon: <FilePdfIcon sx={{ width: '3rem', height: '3rem' }} />,
            },
            {
              label: 'EXCEL',
              value: 'excel',
              icon: <FileExcelIcon sx={{ width: '3rem', height: '3rem' }} />,
            },
          ]}
        />
      </Stack>
    </Box>
  );
};
